"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageTopActionBar = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var ImageTopActionBar = (function (_super) {
    __extends(ImageTopActionBar, _super);
    function ImageTopActionBar(props) {
        var _this = _super.call(this, props) || this;
        _this.onUpload = function () { return __awaiter(_this, void 0, Promise, function () {
            var file, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.fileInput.current || !this.fileInput.current.files) {
                            return [2];
                        }
                        file = this.fileInput.current.files[0];
                        if (!file) {
                            return [2];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.props.uploadImage(file)];
                    case 2:
                        _a.sent();
                        return [3, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.fileInput.current.value = "";
                        return [3, 4];
                    case 4: return [2];
                }
            });
        }); };
        _this.fileInput = react_1.default.createRef();
        return _this;
    }
    ImageTopActionBar.prototype.render = function () {
        var _this = this;
        var _a = this.props, title = _a.title, search = _a.search;
        return (react_1.default.createElement("div", { className: "image-library-top-actions" },
            react_1.default.createElement("div", { className: "image-library-top-actions__folder" },
                react_1.default.createElement("div", { className: "image-library-top-actions__folder-icon" }, title.icon),
                react_1.default.createElement("div", { className: "image-library-top-actions__folder-name" }, title.text)),
            react_1.default.createElement("div", { className: "image-library-top-actions__search-and-upload" },
                !!search && (react_1.default.createElement("div", { className: "image-library-top-actions__search" },
                    react_1.default.createElement(kaleidoscope_1.SearchInput, { label: search.label || "Search", placeholder: search.placeholder || "Search", onChange: search.onValueChange, value: search.value, onClear: search.onClear }))),
                react_1.default.createElement("div", { className: "image-library-top-actions__upload" },
                    react_1.default.createElement(kaleidoscope_1.Button, { className: "image-library-top-actions__upload-label", as: "label", type: kaleidoscope_1.ButtonType.Primary, onKeyDown: function (event) {
                            if (event.key === "Enter" || event.key === " ") {
                                _this.fileInput.current.click();
                            }
                        }, tabIndex: 0 },
                        "Upload",
                        react_1.default.createElement("input", { type: "file", className: "image-library-top-actions__upload-input", ref: this.fileInput, accept: "image/*", onChange: this.onUpload, tabIndex: -1 }))))));
    };
    ImageTopActionBar = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ImageTopActionBar);
    return ImageTopActionBar;
}(react_1.default.Component));
exports.ImageTopActionBar = ImageTopActionBar;
